export class ImmoStudioAssign {
  tourId: number;
  atelierDate: number;
  atelierEmployeeId: number;
  reviewDate: number;
  reviewEmployeeId: number;
  atelierSequence: number;
}
